export default __webpack_public_path__ + "static/media/editMessage.a9571c90.svg";